import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"

export const CheckCircle = (props) => {
  return <FontAwesomeIcon faIcon={faCheckCircle} {...props} />
}
